var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 53,
    viewBox: "0 0 63 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1439 7.5H53.0764C54.1186 7.49989 55.1494 7.717 56.103 8.13747C57.0566 8.55794 57.9121 9.17254 58.615 9.94208C59.3178 10.7116 59.8526 11.6192 60.1851 12.6069C60.5176 13.5946 60.6407 14.6408 60.5464 15.6788L58.1576 41.9287C57.9883 43.7922 57.1285 45.525 55.7471 46.7871C54.3657 48.0491 52.5625 48.7493 50.6914 48.75H11.8864C10.0153 48.7493 8.21202 48.0491 6.83063 46.7871C5.44923 45.525 4.58947 43.7922 4.42014 41.9287L2.03139 15.6788C1.87159 13.9417 2.32537 12.2035 3.31389 10.7663L3.16389 7.5C3.16389 5.51088 3.95407 3.60322 5.36059 2.1967C6.76711 0.790176 8.67476 0 10.6639 0H24.4339C26.4228 0.000424781 28.3302 0.79088 29.7364 2.1975L32.8414 5.3025C34.2476 6.70912 36.1549 7.49958 38.1439 7.5ZM6.93639 7.95C7.73889 7.6575 8.60139 7.5 9.50139 7.5H29.7364L27.0851 4.84875C26.382 4.14544 25.4284 3.75021 24.4339 3.75H10.6639C9.68155 3.74982 8.73836 4.13512 8.03711 4.82304C7.33587 5.51096 6.93255 6.44659 6.91389 7.42875L6.93639 7.95Z",
    fill: "#75D1F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 62.5771,
    height: 52.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.2d685b8c73e6bb460c978a9fbafb3595.svg";
export { ForwardRef as ReactComponent };